import dataPeriTarMon from "../../../../src/data/periprocedureel-beleid-tar-mon-clo-asa.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriTarMon,
  BasicSchematic,
  React
};